<template>
  <div id="layout"/>
</template>

<script>
export default {
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.commit('SET_STATE', { name: 'windowWidth', val: window.innerWidth })
      this.$store.commit('SET_STATE', { name: 'windowHeight', val: window.innerHeight })
    }
  }
}
</script>

<style lang="scss">
  @import "@/styles/global.scss";
</style>
